import { combineEpics } from 'redux-observable';
import { getRoyaltiesAccountEpic } from './get-royalties-account';
import { getRoyaltiesAccountForUserEpic } from './get-royalty-account-for-user';
import { registerRoyaltiesAccountEpic } from './register-royalty-account';
import { deleteRoyaltiesAccountEpic } from './delete-royalties-account';
import { listPayoutsEpic } from './list-payouts';
import { listPayoutsForUserEpic } from './list-payouts-for-user';
import { getBalanceForUserEpic } from './get-balance-for-user';
import { getBalanceEpic } from './get-balance';
import { getStatementsForUserEpic } from './get-statements-for-user';
import { getStatementsEpic } from './get-statements';
import { getBalanceForArtistEpic } from './get-balance-for-artist';
import { getStatementsForArtistEpic } from './get-statements-for-artist';
import { getBalanceAfterTransfer } from './get-balance-after-transfer';

const royaltiesEpic = combineEpics(
  getRoyaltiesAccountEpic,
  getRoyaltiesAccountForUserEpic,
  registerRoyaltiesAccountEpic,
  deleteRoyaltiesAccountEpic,
  listPayoutsEpic,
  listPayoutsForUserEpic,
  getBalanceEpic,
  getBalanceForUserEpic,
  getStatementsForUserEpic,
  getStatementsEpic,
  getBalanceForArtistEpic,
  getStatementsForArtistEpic,
  getBalanceAfterTransfer
);

export default royaltiesEpic;
